import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ManagedLoginService } from 'src/app/shell/services/managed-login.service';

/**
 * Pantalla de callback de autenticacion: procesa el codigo de retorno,
 * guarda tokens y redirige segun los permisos del usuario.
 */
@Component({
  selector: 'app-callback',
  standalone: true,
  imports: [],
  templateUrl: './callback.component.html',
  styleUrl: './callback.component.scss'
})
export class CallbackComponent {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private managedLoginService: ManagedLoginService
  ) {}

  /**
   * Lee el parametro code, solicita tokens y define la navegacion final.
   */
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['code']) {
        try {
          this.managedLoginService.getCognitoToken(params['code']).subscribe({
            next: (response: any) => {

              if (!response || !response.access_token || !response.id_token) {
                console.error("Respuesta invalida del backend:", response);
                return;
              }

              const tokenData = response as { access_token: string; id_token: string; refresh_token: string };

              localStorage.setItem('access_token', tokenData.access_token);
              localStorage.setItem('id_token', tokenData.id_token);
              localStorage.setItem('refresh_token', tokenData.refresh_token);

              this.managedLoginService.scheduleTokenRefresh();

              const userInfo = this.getUserInfo()
              const userGroups = userInfo.cognitoGroups

              if (userGroups.includes('ADMIN_ADMINISTRACION') || userGroups.includes('ACCESS_DEV')) {


                localStorage.setItem('email', userInfo.email);
                localStorage.setItem('apellido', userInfo.apellido);
                localStorage.setItem('nombre', userInfo.nombre);

                this.router.navigate(['/home']);

              }
              else {
                console.error("Acceso denegado: no pertenece al grupo permitido.");
                this.managedLoginService.signOut();
              }

            },
            error: (error) => {
              console.error("Error obteniendo el token:", error);
            }
          });
        } catch (error) {
          console.error("Error en la autenticacion:", error);
        }
      }


    });
  }

  /**
   * Devuelve datos basicos del usuario a partir del token decodificado.
   */
  getUserInfo(): any {
    const decodedToken = this.managedLoginService.decodeToken()

    return {
      cognitoGroups: decodedToken['cognito:groups'] || [],
      email: decodedToken.email,
      nombre: decodedToken.middle_name,
      apellido: decodedToken.family_name,
      sub: decodedToken.sub // Identificador unico del usuario
    };

  }

}
